import router from "@/routes/router";
import { http } from "@/config/http";
import _ from "lodash";

const namespaced = true;

const getDefaultState = () => {
    return {
        errors: [],
        superbos_client_access_token: null,
        user_name: null,
        user_id: null
    };
};

const state = {
    superbos_client_access_token: localStorage.getItem("superbos_client_access_token") || null,
    user_name: localStorage.getItem("user_name") || null,
    user_id: localStorage.getItem("user_id") || null
};

const getters = {
    loggedIn() {
        return localStorage.getItem("superbos_client_access_token") != null;
    },
};

const mutations = {
    setFormErrors(state, data) {
        state.errors = [];
        if (data) {
            state.errors = data.details;
        }
    },
    doLogin(state, response) {
        let contentData = response.data;
        const token = contentData.token;
        if (token) {
            localStorage.setItem("superbos_client_access_token", token);
            localStorage.setItem("user_name", contentData.name);
            localStorage.setItem("user_id", contentData.id);
            state.user_id = contentData.id;
            state.superbos_client_access_token = token;
            state.user_name = contentData.name;
            router.push({ name: 'claimwizard' });
        } else {

        }
    },

    doLogout(state) {
        localStorage.removeItem("superbos_client_access_token");
        localStorage.removeItem("user_name");
        localStorage.removeItem("user_id");
        state.superbos_client_access_token = null;
        state.user_name = null;
        state.user_id = null;
        router.push({ name: 'Login' });
    },

    clearLogin(state) {
        localStorage.removeItem("superbos_client_access_token");
        localStorage.removeItem("user_name");
        localStorage.removeItem("user_id");
        state.superbos_client_access_token = null;
        state.user_name = null;
        state.user_id = null;
    },
};

const actions = {

    async login({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("Clients/authenticate", data)
                .then(response => {
                    if (response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.error,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    } else {
                        commit("doLogin", response);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async destroyToken({ commit }) {
        await http
            .post("auth/logout", null, {})
            .then(response => {
                if (response.data.status == "true") {
                    commit("doLogout");
                } else {
                    commit("doLogout");
                }
            })
            .catch(error => {
                commit("handleExceptions", error, { root: true });
                commit("doLogout");
            });
    },

};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
